export default __webpack_public_path__ + "static/media/electric-guitar (2).2a37c953.png";